var _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgChangelog = function SvgChangelog(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 5,
    width: 3,
    height: 3,
    rx: 1,
    fill: "currentColor"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 13,
    width: 3,
    height: 3,
    rx: 1,
    fill: "currentColor"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 5,
    width: 11,
    height: 2,
    rx: 1,
    fill: "currentColor"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 13,
    width: 11,
    height: 2,
    rx: 1,
    fill: "currentColor"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 9,
    y: 9,
    width: 7,
    height: 2,
    rx: 1,
    fill: "currentColor"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 9,
    y: 17,
    width: 7,
    height: 2,
    rx: 1,
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgChangelog);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "changelog.4c9971c2a901f25b32fa23f272b8d066.svg";